import aHttp from '@/models/axiosConfig/aHttp';
import constants from '@/constants';
const {
  API_LIST: { MINIAPP_PROD, EMTCSLP_EXTERNAL_APIGATEWAY_PROD }
} = constants;

const urls = {
  getNewCustomerPromotions: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/promotion/getNewCustomerPromotions`, // Obtain new user coupons ids
  getReferralCustomerPromotions: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/promotion/getReferralCustomerPromotions`, // Obtain promotional coupons ids
  getPromotionInfosByPromotionIds: `${MINIAPP_PROD}/dps/promotion/GetPromotionInfosByPromotionIds`, // Get details by coupon ID
  redeemNewCustomerPromotions: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/promotion/redeemNewCustomerPromotions`, // Claim new user coupons
  redeemPromotionForCurrentCustomer: `${MINIAPP_PROD}/dps/promotion/redeemPromotionForCurrentCustomer`, // Receive coupon cards
  getCustomerActualPurchase: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/customer/getCustomerActualPurchase`, // Verify whether the user has placed an order for the first time
  getPromotionStatusByPromotionIds: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/promotion/getPromotionStatusByPromotionIds`
};

export const handleRequestParams = promotionsIds => {
  let requestData = '';
  if (promotionsIds) {
    requestData = promotionsIds
      .map(
        promotionId =>
          `encryptedPromotionIdList=${encodeURIComponent(promotionId)}`
      )
      .join('&');
    requestData += '&withRedeemedCouponStatus=0';
  }
  return requestData;
};

export const getNewCustomerPromotions = (params, header = {}) =>
  aHttp.get(urls.getNewCustomerPromotions, params, header);
export const getReferralCustomerPromotions = params =>
  aHttp.get(urls.getReferralCustomerPromotions, params);
export const getPromotionInfosByPromotionIds = (params, header = {}) =>
  aHttp.get(
    `${urls.getPromotionInfosByPromotionIds}?${handleRequestParams(params)}`,
    header
  );
export const redeemNewCustomerPromotions = params =>
  aHttp.post(urls.redeemNewCustomerPromotions, params);
export const redeemPromotionForCurrentCustomer = params =>
  aHttp.get(urls.redeemPromotionForCurrentCustomer, params);
export const getCustomerActualPurchase = params =>
  aHttp.get(urls.getCustomerActualPurchase, params);
export const getPromotionStatusByPromotionIds = params =>
  aHttp.get(`${urls.getPromotionStatusByPromotionIds}?${params}`);
